import { Separator } from "components/ui/separator";
import { Skeleton } from "components/ui/skeleton";
import { useNavigate } from "react-router-dom";
import { RouteUrl } from "utils";
import UserList from "components/app/flipflop/user-list/UserList";

interface LeftSideConetnetUserFollowersAndReachsState {
  topTenFollowers: any[];
  topTenFollowerLoading: boolean;
  topTenReachs: any[];
  topTenReachLoading: boolean;
}

export default function LeftSideConetnetUserFollowersAndReachs({
  topTenFollowers,
  topTenFollowerLoading,
  topTenReachs,
  topTenReachLoading,
}: LeftSideConetnetUserFollowersAndReachsState) {
  const navigate = useNavigate();

  return (
    <div className="p-4">        
      {topTenReachLoading ? (
        <div className="">
          <Skeleton className="h-4 w-[200px] mb-2" />
          {[...Array(10)].map((_: any, index: number) => {
            return (
              <div
                key={index}
                className="flex items-center mt-2 space-x-2 ml-2  w-full"
              >
                <Skeleton className="w-12 h-12 rounded-full shrink-0" />
                <div className="space-y-2 w-full">
                  <Skeleton className="h-3 w-3/4" />
                  <Skeleton className="h-2 w-2/4" />
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div>
          <h4 className="text-sm font-semibold mb-2">Top 10 Scorers</h4>
          {topTenReachs?.map((user, index) => (
            <div
              key={user.id}
              className="rounded-lg cursor-pointer max-w-full overflow-x-hidden"
              onClick={() => {
                navigate(`${RouteUrl.profile}?id=${user?.id}`);
              }}
            >
              <UserList user={user} />
            </div>
          ))}
        </div>
      )}
      <Separator className="my-2" />
      {topTenFollowerLoading ? (
        <div className="">
          <Skeleton className="h-4 w-[200px] mb-2" />
          {[...Array(10)].map((_: any, index: number) => {
            return (
              <div
                key={index}
                className="flex items-center mt-2 space-x-2 ml-2  w-full"
              >
                <Skeleton className="w-12 h-12 rounded-full shrink-0" />
                <div className="space-y-2 w-full">
                  <Skeleton className="h-3 w-3/4" />
                  <Skeleton className="h-2 w-2/4" />
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="">
          <h4 className="text-sm font-semibold mb-2">Top 10 Followers</h4>
          {topTenFollowers?.map((user, index) => (
            <div
              key={user.id}
              className="rounded-lg cursor-pointer max-w-full overflow-x-hidden"
              onClick={() => {
                navigate(`${RouteUrl.profile}?id=${user?.id}`);
              }}
            >
              <UserList user={user} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

